module.exports = __webpack_public_path__ + "static/media/profile-google-hk.2ec74f48.png";